// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3QSMo","comment":"styles_comment__18Hb0"};